import {ExampleBookConfig} from './config';

export const fetchExampleFile = async (config: ExampleBookConfig): Promise<File> => {
  const response = await fetch(config.publicUrl);
  if (!response.ok) {
    throw new Error(`Failed to fetch example book from ${config.publicUrl}`);
  }

  const blob = await response.blob();
  return new File([blob], config.fileName, {type: config.mime});
};
